<div style="text-align:center; margin-top: 150px;">
  <h1 style="font-size: 4em;">
    Message: <span style="color: red;">{{ message }}</span>
  </h1>
</div>
